/**
 * GST / billing profile used on Subscription Management.
 */
import GstLocationFields from '../../shared/GstLocationFields';
import { gstinSideEffects, isPanAutoFromGstin } from '../../../../utils/invoiceSettingsForm';

export default function GstDetailsForm({
  values,
  errors = {},
  saving = false,
  onChange,
  onSubmit,
}) {
  const gstEnabled = values.invoice_gst_enabled !== false && values.invoice_gst_enabled !== '0';
  const panAutoFilled = isPanAutoFromGstin(values);

  function handleInput(event) {
    const { name, value, type, checked } = event.target;
    if (name === 'invoice_gst_enabled') {
      onChange(name, checked);
      return;
    }
    if (name === 'gst_no') {
      onChange(gstinSideEffects(value, values));
      return;
    }
    if (name === 'pan_no') {
      onChange(name, value.toUpperCase());
      return;
    }
    onChange(name, value);
  }

  return (
    <form className="sub-mgmt-gst-form" onSubmit={onSubmit}>
      <div className="sub-mgmt-gst-intro">
        <h5>GST details</h5>
        <p>
          Save the GSTIN and location used on subscription invoices. State and district
          are searchable dropdowns — type to filter.
        </p>
      </div>

      <div className="form-check form-switch mb-4">
        <input
          className="form-check-input"
          type="checkbox"
          id="sub-gst-enabled"
          name="invoice_gst_enabled"
          checked={gstEnabled}
          onChange={handleInput}
        />
        <label className="form-check-label fw-semibold" htmlFor="sub-gst-enabled">
          Registered under GST
        </label>
      </div>

      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label fw-semibold" htmlFor="gst-dealer">
            Legal / trade name <span className="text-danger">*</span>
          </label>
          <input
            id="gst-dealer"
            name="dealer"
            className="form-control"
            value={values.dealer || ''}
            onChange={handleInput}
            placeholder="Name as on GST certificate"
          />
          {errors.dealer && <small className="text-danger">{errors.dealer}</small>}
        </div>
        {gstEnabled && (
          <>
            <div className="col-md-6">
              <label className="form-label fw-semibold" htmlFor="gst-gstin">
                GSTIN <span className="text-danger">*</span>
              </label>
              <input
                id="gst-gstin"
                name="gst_no"
                className="form-control text-uppercase"
                maxLength={15}
                value={values.gst_no || ''}
                onChange={handleInput}
                placeholder="15-character GSTIN"
                autoComplete="off"
              />
              {errors.gst_no && <small className="text-danger">{errors.gst_no}</small>}
              <small className="text-muted d-block mt-1">
                State and PAN are filled from the GSTIN (first 2 digits and characters 3–12).
              </small>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold" htmlFor="gst-pan">PAN</label>
              <input
                id="gst-pan"
                name="pan_no"
                className="form-control text-uppercase"
                maxLength={10}
                value={values.pan_no || ''}
                onChange={handleInput}
                readOnly={panAutoFilled}
                placeholder="Auto-filled from GSTIN"
                title={panAutoFilled ? 'Auto-filled from GSTIN (characters 3–12)' : undefined}
              />
              {panAutoFilled ? (
                <small className="text-muted d-block mt-1">Auto-filled from GSTIN</small>
              ) : null}
              {errors.pan_no && <small className="text-danger">{errors.pan_no}</small>}
            </div>
          </>
        )}
        <div className="col-12">
          <GstLocationFields
            stateCode={values.pump_state_code}
            district={values.pump_district}
            errors={errors}
            onChange={onChange}
          />
        </div>
        <div className="col-12">
          <label className="form-label fw-semibold" htmlFor="gst-address">
            Billing address <span className="text-danger">*</span>
          </label>
          <textarea
            id="gst-address"
            name="invoice_address"
            className="form-control"
            rows={3}
            value={values.invoice_address || ''}
            onChange={handleInput}
            placeholder="Address for subscription invoices"
          />
          {errors.invoice_address && <small className="text-danger">{errors.invoice_address}</small>}
        </div>
        <div className="col-md-6">
          <label className="form-label fw-semibold" htmlFor="gst-phone">Phone</label>
          <input
            id="gst-phone"
            name="pump_phone"
            className="form-control"
            value={values.pump_phone || ''}
            onChange={handleInput}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label fw-semibold" htmlFor="gst-email">Email</label>
          <input
            id="gst-email"
            name="pump_email"
            type="email"
            className="form-control"
            value={values.pump_email || ''}
            onChange={handleInput}
          />
        </div>
      </div>

      <div className="mt-4">
        <button type="submit" className="btn sub-mgmt-btn-primary sub-mgmt-gst-save" disabled={saving}>
          {saving ? (
            <><i className="fa fa-spinner fa-spin me-1" /> Saving…</>
          ) : (
            <><i className="fa fa-save me-1" /> Save GST details</>
          )}
        </button>
      </div>
    </form>
  );
}
